"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseUnitOf = exports.getAllUnitsOf = exports.findUnitBySymbol = exports.isBaseUnit = void 0;
const exception_1 = require("../exception");
const units = __importStar(require("./const"));
const isBaseUnit = (unit) => unit.multiplier === 1;
exports.isBaseUnit = isBaseUnit;
const SYMBOL_MAPPING = new Map([
    // Length.
    ["mm", units.millimeter],
    ["cm", units.centimeter],
    ["m", units.meter],
    ["km", units.kilometer],
    // Mass.
    ["mg", units.milligram],
    ["g", units.gram],
    ["kg", units.kilogram],
    // Time.
    ["ms", units.millisecond],
    ["s", units.second],
    ["min", units.minute],
    ["h", units.hour],
    ["d", units.day],
]);
const findUnitBySymbol = (symbol) => SYMBOL_MAPPING.get(symbol);
exports.findUnitBySymbol = findUnitBySymbol;
const ALL_UNIT_MAPPING = new Map([
    ["Length", units.allLengthUnits],
    ["Mass", units.allMassUnits],
    ["Time", units.allTimeUnits],
]);
const getAllUnitsOf = (type) => {
    const result = ALL_UNIT_MAPPING.get(type);
    if (!result) {
        throw new exception_1.UnitError(`Unrecognized unit type: ${type}`);
    }
    return result;
};
exports.getAllUnitsOf = getAllUnitsOf;
const BASE_UNIT_MAPPING = new Map([
    ["Length", units.meter],
    ["Mass", units.kilogram],
    ["Time", units.second],
]);
const getBaseUnitOf = (type) => {
    if (type != null) {
        const result = BASE_UNIT_MAPPING.get(type);
        if (!result) {
            throw new exception_1.UnitError(`Unrecognized unit type: ${type}`);
        }
        return result;
    }
    return undefined;
};
exports.getBaseUnitOf = getBaseUnitOf;
